import { useEffect, useState } from "react";
import { message } from "antd";
import CrudHeader from "../CrudHeader";
import UnidadMedidaTable from "./UnidadMedidaTable";
import UnidadMedidaForm from "./UnidadMedidaForm";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../../store/auth/selectors';

import { getUnidadesMedida, createUnidadMedida, updateUnidadMedida, deleteUnidadMedida } from "../../../../services/financiero/finUnidadMedidaService";
export default function UnidadMedidaPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const appName = 'unidad_medida_financiero';
  const permissions = useSelector((state) => selectAppPermissions(state, appName) );
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionAccess = permissions.priv_access === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await getUnidadesMedida();
      setData(res);
    } catch (error) {
      message.error("Error cargando unidades de medida");
    }
    setLoading(false);
  };

  useEffect(() => {
    cargar();
  }, []);

  const handleCreate = () => {
    if (!permissionInsert) {
      message.warning("No tiene permisos para crear unidades");
      return;
    }
    setEditing(null);
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    if (!permissionUpdate) {
      message.warning("No tiene permisos para editar");
      return;
    }
    setEditing(record);
    setModalOpen(true);
  };

  const handleDelete = async (record) => {
    if (!permissionDelete) {
      message.warning("No tiene permisos para eliminar");
      return;
    }
    try {
      await deleteUnidadMedida(record.oid, userLogin);
      message.success("Unidad eliminada");
      cargar();
    } catch {
      message.error("Error eliminando unidad");
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editing) {
        await updateUnidadMedida(
          editing.oid,
          values,
          userLogin
        );
        message.success("Unidad actualizada");
      } else {
        await createUnidadMedida(
          values,
          userLogin
        );
        message.success("Unidad creada");
      }
      setModalOpen(false);
      cargar();
    } catch {
      message.error("Error guardando unidad");
    }
  };

  if (!permissionAccess) {
    return <div>No tiene permisos para acceder a este módulo</div>;
  }
  return (
    <div>
      <CrudHeader
        title="Unidades de Medida"
        onCreate={handleCreate}
         permissionInsert={permissionInsert}
      />
      <div style={{ maxWidth: 1000, margin: "0 auto", }}>

        <UnidadMedidaTable
          data={data}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          permissionDelete={permissionDelete}
          permissionUpdate={permissionUpdate}
        />
      </div>
      <UnidadMedidaForm
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editing}
      />
    </div>
  );
}